import { GameStatus } from "../../models/GameStatus";
import store from "../../store/store";
import Card from "../Card/Card";
import "./Table.scss";
import classNames from 'classnames';
import React, { useEffect } from "react";



export default function TableHidden() {
  const gameState = store.getState().game;
  const players = gameState.players;
  const playersSize = gameState.players.length;
  const isMatching = gameState.status === GameStatus.MATCH;

  let matchedCardsAmount = 0;

  gameState.players.forEach(it => {
    if (isMatching && it.hasMatched) {
      matchedCardsAmount++;
    }
  });

  useEffect(() => {
    const img = new Image();
    img.src = gameState.settings.cardBack;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const gameTableClassNames = classNames({
    'game-table': true,
    'game-table_hidden': true,
    [`game-table-${players.length}`]: true
  });

  return (
    <div className={gameTableClassNames}>
      {playersSize > 0 &&
        players.map((it, i) => {
          const isPlaceholder = (i + 1) > matchedCardsAmount;

          const classnames = classNames({
            'game-card': true,
            'game-card_hidden': true,
            'game-card_placeholder': isPlaceholder,
          });

          return (
            <React.Fragment key={i}>
              {isPlaceholder &&
                <div className={classnames}></div>
              }
              {!isPlaceholder &&
               <React.Fragment>
                <Card
                  classes={classnames}
                  card={{cardId: `${i}`, src: gameState.settings.cardBack}}
                  isLongPressEnabled={false}
                  isSelectable={true}
                />
                </ React.Fragment>
              }
            </ React.Fragment>
          )
        })
      }
    </div>
  )
}